'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = require('prop-types');

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track2 = require('./utils/track');

var _track3 = _interopRequireDefault(_track2);

var _events = require('./events');

var _traits = require('./traits');

var _getUserPackage = require('./utils/cookie/getUserPackage');

var _getUserPackage2 = _interopRequireDefault(_getUserPackage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_PACKAGE, _propTypes3.default.string);

/**
 * Wrapper function to trigger SegmentIO function to track a login
 * @param traits
 * @returns call of SegmentIO track function
 */

function trackLogin() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    // eslint-disable-next-line no-console
    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_LOG_IN + ' event');
    return (0, _track3.default)(_events.EVENT_LOG_IN, (0, _defineProperty3.default)({}, _traits.TRAIT_PACKAGE, traits[_traits.TRAIT_PACKAGE] || (0, _getUserPackage2.default)()));
}

exports.default = trackLogin;


//////////////////
// WEBPACK FOOTER
// ./~/rp-betting-special-offer/~/rp-analytics/lib/trackLogin.js
// module id = 1813
// module chunks = 0